import selectBoxLookupItemUrl from './selectBoxLookupItem.html';

export default {
  templateUrl: selectBoxLookupItemUrl,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    item: '<',
    onSelect: '&',
  },
};
